import React, { useState } from "react";
import "./Ordered_Product_details_card.css";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleExclamation,
  faPen,
  faBell,
  faEnvelope,
  faShoppingBag,
} from "@fortawesome/free-solid-svg-icons";
import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import { useNavigate } from "react-router-dom";

function Ordered_Product_details_card() {
  const navigate = useNavigate();
  const handleAddToCart = () => {
    setQty(1);
  };

  const [qty, setQty] = useState(0);

  const increaseQty = () => setQty((prev) => prev + 1);
  const decreaseQty = () => setQty((prev) => (prev > 0 ? prev - 1 : 1));

  return (
    <>
      <section className="Ordered_Product_details_card">
        {/* Product Details Card */}
        <div className="white_card">
          {/* Title */}
          <h2 className="product_title">GPAC URI PITCHER</h2>

          {/* Price Row */}
          <div className="price_row">
            <div className="d-flex gap-3">
              <p className="mrp">
                MRP. <span>34660</span>
              </p>

              <p className="price">
                <b> Selling Price: ₹ 2000 </b>
              </p>
            </div>

            <p className="discount">30% Discount</p>
          </div>

          {/* Short Description */}
          <p className="desc">
            Hammered 1500ml (Copper Pitcher with tumbler cum lid)
          </p>

          <p className="desc">
            Hand-crafted Copper pitcher made of pure Copper (purity above 99.5%)
          </p>

          {/* Stock Row */}
          <div className="stock_row">
            <span className="tag">Only 3 left</span>
            <p className="availability">
              Availability : <span>In stock</span>
            </p>
          </div>

          {/* Small Info */}
          <p className="small_info">
            GPAC x Copperkraft Uri - Hand-crafted, pure Copper pitcher, 1500 ml,
            hammered finish
          </p>

          <div className="dotted_line"></div>

          {/* Seller */}
          <p className="seller">
            SELLER: <span>MITTAL COIN PVT. LTD.</span>
          </p>

          <div className="seller_links">
            <Link to={"/"}>View All Products</Link>
            <span className="pipe">|</span>
            <Link to={"/"}>View Profile</Link>
            <span className="pipe">|</span>
            <Link to={"/"}>Ask Product Question</Link>
          </div>

          <div className="dotted_line"></div>

          {/* Coins Info */}
            <Link  to={"/luxury/my-rewards"}>
          <div className="coin_info">
            <FontAwesomeIcon icon={faCircleExclamation} className="info_icon" />
            <p>You will earn 39 Points for purchasing this product.</p>
          </div>
            </Link>

          <div className="dotted_line"></div>

          {/* Qty */}

          {/* ✅ Show Add To Cart only when qty = 0 */}
          {qty === 0 && (
            <div
              className="add_to_cart_btn btn_holder"
              onClick={handleAddToCart}
            >
              <Purple_Btn btnText={"Add To Cart"} leftIcon={faShoppingBag} />
            </div>
          )}

          {/* ✅ Show qty_row only when qty > 0 */}
          {qty > 0 && (
            <>
            <div className="btn_holder">

            <div className="qty_row">
              <button className="qty_btn" onClick={decreaseQty}>
                -
              </button>

              <p className="qty_value">{qty}</p>

              <button className="qty_btn" onClick={increaseQty}>
                +
              </button>
            </div>
             <div
              className="add_to_cart_btn btn_holder"
              onClick={() => navigate("/luxury/cart")}
            >
              <Purple_Btn btnText={"Go To Cart"} leftIcon={faShoppingBag} />
            </div>
            </div>
            </>
          )}
          <div className="dotted_line"></div>

          {/* Bottom Links */}
          <div className="bottom_links">
            <div className="left_links">
              <div className="single_link">
                <FontAwesomeIcon icon={faPen} className="mini_icon" />
                <p>Be the first to review this product</p>
              </div>

              <div className="single_link">
                <FontAwesomeIcon icon={faBell} className="mini_icon" />
                <p>Sign up for price alert</p>
              </div>
            </div>

            <div className="right_link">
              <FontAwesomeIcon icon={faEnvelope} className="mini_icon" />
              <p>Email to Friend</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Ordered_Product_details_card;
